export default __webpack_public_path__ + "static/media/background_vid.674f03f9.mp4";